/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import React, { useState } from "react";
import axios from "axios"; // Import Axios

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "layouts/tables/data/authorsTableData";
import { Password } from "@mui/icons-material";
import { baseurl } from "domain";
import { useNavigate } from "react-router-dom";

import {
  TextField,
  Button,
  Container,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  Grid,
  Box,
} from "@mui/material";
// import Box from '@mui/material/Box';
import FormControl from "@mui/material/FormControl";
import AddUserEx from "components/module2";
// import Loading from "components/Loading";

function Tables() {
  const { columns, rows } = authorsTableData();
  // const [loading, setLoading] = useState(true); // Loading state
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    fullName: "", //text
    gender: "", //dropdown
    email: "", //text
    phone: "",
    r_address: "",
    education: "",
    bloodGroup: "",
    dob: "", //calender
    organization: "",
    experience: "", //text
    designation: "",
    o_address: "",
    membershipType: "", //dropdown
    membershipStart: "", //calender
    membershipExp: "", //calender
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formValues);

    const formData = new FormData();

    try {
      const response = await axios.post(`https://${baseurl}/addMember`, formValues);
      console.log("Question submitted successfully:", response.data);
      alert("Member added successfully!");
      navigate("/Members");
    } catch (error) {
      console.error("Error submitting question:", error);
    } finally {
      // setLoading(false);
    }
  };
  // if (loading) {
  //   return <Loading />; // Show loading component if data is still loading
  // }
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    alert("Button clicked!");
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                  <Grid item>
                    <MDTypography variant="h6" color="white">
                      Add Member
                    </MDTypography>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="white"
                      onClick={handleOpen}
                      style={{ backgroundColor: "white", color: "#0076CE" }}
                    >
                      + Import Bulk Member
                    </Button>
                    <AddUserEx open={open} onClose={handleClose} />
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <Container maxWidth="sm">
                  <Typography variant="h4" component="h1" gutterBottom>
                    Members Form
                  </Typography>
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Full Name"
                          name="fullName"
                          value={formValues.fullName}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ minWidth: 120 }}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel>Gender</InputLabel>
                            <Select
                              name="gender"
                              value={formValues.gender}
                              label="Gender"
                              onChange={handleChange}
                              style={{ padding: 12 }}
                            >
                              <MenuItem value={"Male"}>Male</MenuItem>
                              <MenuItem value={"Female"}>Female</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Email"
                          name="email"
                          value={formValues.email}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Phone"
                          name="phone"
                          value={formValues.phone}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Residential Address"
                          name="r_address"
                          value={formValues.r_address}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Education"
                          name="education"
                          value={formValues.education}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Blood Group"
                          name="bloodGroup"
                          value={formValues.bloodGroup}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Date of Birth"
                          name="dob"
                          type="date" // This ensures the input works as a date picker
                          value={formValues.dob}
                          onChange={handleChange}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true, // Keeps the label visible when a date is selected
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Organization"
                          name="organization"
                          value={formValues.organization}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Experience"
                          name="experience"
                          value={formValues.experience}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Designation"
                          name="designation"
                          value={formValues.designation}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Office Address"
                          name="o_address"
                          value={formValues.o_address}
                          onChange={handleChange}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box sx={{ minWidth: 120 }}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel>Membership Type</InputLabel>
                            <Select
                              name="membershipType"
                              value={formValues.membershipType}
                              label="Membership Type"
                              onChange={handleChange}
                              style={{ padding: 12 }}
                            >
                              <MenuItem value={"General Member"}>General Member</MenuItem>
                              <MenuItem value={"Associate Member"}>Associate Member</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Membership Start"
                          name="membershipStart"
                          type="date" // This ensures the input works as a date picker
                          value={formValues.membershipStart}
                          onChange={handleChange}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true, // Keeps the label visible when a date is selected
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Membership Expiry"
                          name="membershipExp"
                          type="date" // This ensures the input works as a date picker
                          value={formValues.membershipExp}
                          onChange={handleChange}
                          variant="outlined"
                          InputLabelProps={{
                            shrink: true, // Keeps the label visible when a date is selected
                          }}
                        />
                      </Grid>

                      <Grid item xl={12} sl={"auto"} paddingBottom={4}>
                        <Box
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          height="100%"
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            style={{ color: "white" }}
                          >
                            Add Member
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  </form>
                </Container>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Tables;
